module.exports = __webpack_public_path__ + "img/hero-bg-effect.ff65db66.png";